module.exports = __webpack_public_path__ + "img/9788983946553.ddb59a30.jpg";